export const CHECK_ACCOUNT = 'checkAccount'
export const CHECK_STORED_TOKENS = 'checkStoredTokens'
export const CHECK_USER_TOKEN_VALIDITY = 'checkUserTokenValidity'
export const GET_CONFIGURATION = 'getConfiguration'
export const GET_CONFIGURATION_SETTINGS = 'getConfigurationSettings'
export const GET_ACCOUNTS = 'getAccounts'
export const GET_USER_INFOS = 'getUserInfos'
export const GET_USER_TOKEN = 'getUserToken'
export const LOGIN = 'logIn'
export const LOGOUT = 'logOut'
export const REFRESH_TOKEN = 'refreshToken'
export const SYNC_LOGIN = 'syncLogin'
export const SYNC_LOGOUT = 'syncLogout'
export const SYNC_REFRESH = 'syncRefresh'
export const SYNC_UNREGISTER = 'syncUnregister'
export const SYNC_USER_STATUS = 'syncUserStatus'
export const UNREGISTER = 'unregister'
